import React, { PropTypes, PureComponent } from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';
import NextNavButton from './NextNavButton';
import PrevNavButton from './PrevNavButton';

class Carousel extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false
        };
        this.onClick = this.onClick.bind(this);
    }
    componentDidMount() {
        this.setInitialized();
    }
    componentDidUpdate() {
        this.setInitialized();
    }
    onClick(event) {
        if (event) {
            event.preventDefault();
        }
        const { contents, onClick } = this.props;
        const contentId = event.currentTarget.getAttribute('data-id');
        const content = contents.filter(({ id }) => id === contentId)[0];
        if (onClick) {
            onClick(content);
        }
    }
    setInitialized() {
        if (!this.sliderContainer) {
            return;
        }
        this.sliderContainer.classList.remove('carousel-loading');
        // a little hack to trigger `update` function on `react-slick` to calculate `sliderWidth`
        // right after the carousel gets visible
        if (!this.state.initialized) {
            this.setState({ // eslint-disable-line react/no-did-mount-set-state
                initialized: true
            });
        }
    }
    render() {
        const { contents } = this.props;
        if (!contents.length) {
            return null;
        }
        const isSingleItem = contents.length === 1;
        const settings = {
            autoplay: true,
            autoplaySpeed: 6000,
            pauseOnFocus: true,
            pauseOnHover: true,
            speed: 400,
            swipe: true,
            pauseOnDotsHover: true,
            arrows: !isSingleItem,
            dots: !isSingleItem,
            className: classnames('dtc-watch__carousel', { 'dtc-watch__carousel--single': isSingleItem }),
            dotsClass: 'dtc_carousel__dots',
            prevArrow: <PrevNavButton />,
            nextArrow: <NextNavButton />,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }
            ]
        };

        const items = contents.map(({ id, name, imageHref }) => (
            <div key={imageHref} className="dtc-watch__carousel__item">
                <a data-id={id} onClick={this.onClick}>
                    <img src={imageHref} alt={name} />
                </a>
            </div>
        ));

        return (
            <div
                ref={ele => { this.sliderContainer = ele; }}
                className="dtc-watch__carousel--container carousel-loading"
            >
                <Slider {...settings}>
                    {items}
                </Slider>
            </div>
        );
    }
}

Carousel.propTypes = {
    contents: PropTypes.array,
    onClick: PropTypes.func
};

Carousel.defaultProps = {
    contents: []
};

export default Carousel;



// WEBPACK FOOTER //
// ./app/common/page/carousel/Carousel.js